'use client';

import { Text } from '@/shared/ui/core';
import { AuthCardContent, AuthCardDescription, AuthCardHeader, AuthCardLogo, AuthCardTitle } from '@/shared/ui/layout/auth-card';
import { RegistrationCard } from '@/shared/ui/layout/registration-card';
import { ResendVerification } from '@/features/auth/resend-verification';
import { useWizard } from '../../model/wizard-context';
import styles from './step-confirmation.module.scss';


export const StepConfirmation = () => {
    const { state } = useWizard();

    return (
        <RegistrationCard
            data-template="registration-steps-card"
            compact
        >
            <div data-template="step-email">
                <AuthCardLogo data-template="email-form-logo"/>

                <AuthCardHeader data-template="email-form-header">
                    <AuthCardTitle
                        data-template="email-form-title"
                        className={ styles.title }
                    >
                        Please check your email!
                    </AuthCardTitle>
                    <AuthCardDescription
                        data-template="email-form-description"
                        className={ styles.description }
                    >
                        Thanks for signing up! Before getting started, could you verify your email address by clicking on
                        the link we just emailed to you?
                    </AuthCardDescription>
                </AuthCardHeader>

                <AuthCardContent data-template="step-email-content">
                    <Text
                        as="p"
                        size="lg"
                        tone="secondary"
                        className={ styles.content_text }
                    >
                        If you didn&apos;t receive the email, we will gladly send you another.
                    </Text>

                    <div className={ styles.controls }>
                        <ResendVerification email={ state.data.credentials?.email ?? '' }/>
                    </div>
                </AuthCardContent>
            </div>
        </RegistrationCard>
    );
};
